"use client";

import { useEffect, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Partners() {
  const [isZh, setIsZh] = useState(false);
  useEffect(() => {
    const checkLang = () => {
      setIsZh(localStorage.getItem("elite-language") === "zh-Hant");
    };
    checkLang();
    window.addEventListener("storage", checkLang);
    return () => window.removeEventListener("storage", checkLang);
  }, []);
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const integrations = [];
  return <section data-section-id="15536" id="our-global-partners" className="bg-background text-foreground border-t border-border py-24 md:py-32">
      <div className="mx-auto max-w-[1320px] px-5 !bg-[rgba(255,255,255,1)] md:px-8">
        <div ref={ref} className={`mx-auto max-w-3xl text-center transition-all duration-[380ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"}`}>
          <div className="font-mono text-xs font-medium uppercase tracking-[0.08em] text-muted-foreground">
            {isZh ? "全球合作夥伴" : "GLOBAL PARTNERSHIPS"}
          </div>
          <h2 className="mt-6 font-default text-[clamp(2rem,3.8vw,3rem)] font-semibold leading-[1.04] tracking-[-0.022em]">
            {isZh ? <>以<em className="italic">全球標準</em>支持卓越製造。</> : <>Manufacturing excellence backed by <em className="italic">global standards</em>.</>}
          </h2>
          <p className="mt-5 font-default text-[clamp(0.9375rem,0.95vw,1rem)] leading-[1.55] text-muted-foreground">
            {isZh ? "我們與全球領先的檢測實驗室及認證機構緊密合作，確保每件產品均符合最嚴格的國際安全與品質標準。" : "We collaborate with world-leading testing laboratories and certification bodies to ensure every product meets the highest international safety and quality benchmarks."}
          </p>
        </div>

        <div className="mt-16 grid grid-cols-2 border-l border-t border-border sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
          {integrations.map((item, i) => <div data-index={i} key={item.name} className="group relative flex h-[140px] items-center justify-center border-b border-r border-border px-4 transition-colors duration-200 hover:bg-accent">
              
            </div>)}
        </div>
      </div>
    </section>;
}